export default {
  title: '¿No encuentra lo que busca? Nosotros se lo diseñamos.',
  subTitle:
    'Si necesita una ilustración, imagen, dibujo o icono científico que aún no está disponible en nuestra galería, puede solicitarlo y lo crearemos para usted. Siga estos pasos:',
  stepOne:
    'Vaya al espacio de trabajo y haga clic en el botón "Solicitar un Botón "Ilustración", en la parte inferior izquierda de tu pantalla.',
  stepTwo:
    'Rellene el formulario con los datos detalles sobre el ilustración científica que necesidad. También puede adjuntar referencias, como mano dibujos y otros imágenes.',
  stepThree:
    'Su solicitud debe tener unos 7 días laborables para prepárate. Recibirás correo electrónico cuando el científic ilustración disponible.',
  text: 'También puede solicitar ahora una ilustración haciendo clic en el siguiente botón',
  textButton: 'Solicite una ilustración ahora',
};
